const noop = () => {};

// Env-gated logger: debug output is disabled entirely in production builds.
export const debugLog =
    process.env.NODE_ENV !== "production" ? console.debug.bind(console) : noop;
